module.exports = __webpack_public_path__ + "static/media/secconn.fd5275bd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/secconn.png
 ** module id = 1621
 ** module chunks = 0
 **/